// extracted by mini-css-extract-plugin
export default {"add-branch-modal__body":"add-branch-modal_add-branch-modal__body__zMX2b","add-branch-modal__content":"add-branch-modal_add-branch-modal__content__EEn6S"};